"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var isJson = function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
};
exports.default = isJson;
//# sourceMappingURL=isJson.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/isJson.js